import {apiService} from "features/jwt/apiService";
import {apiErrorFrom} from "features/errors";
import {ChatServiceEndpoints} from "features/chat/services/ChatService/config";
import {SendMessageParams, SendMessageResponse} from "features/chat/services/ChatService/types";

export class ChatService {
    public static readonly SendMessage = async (messageParams: SendMessageParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<SendMessageResponse>(ChatServiceEndpoints.sendMessage(), messageParams);

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    }
}
